export const navItems = [
  { text: 'Home', isActive: true },
  { text: 'Advisory', isActive: true },
  { text: 'Prive', isActive: false },
  { text: 'IRIS', isActive: true },
  { text: 'Ethosphere', isActive: true }
];

export const officeLocations = [
  {
    country: 'UAE',
    address: 'UAE: Office 501, 05th FLoor, Innovation One, DIFC, Dubai, UAE',
    iconSrc: 'https://cdn.builder.io/api/v1/image/assets/TEMP/7d66de7efa5633b2a7db991eceed639fc3a4880abdc7438a8eb374edf0e0b531?placeholderIfAbsent=true&apiKey=8031103fb59b4417b3d6df6558972104',
  },
  {
    country: 'India',
    address: 'India: Unit No. 501, 5th Floor, Parinee I, Plot No. 7/A, Off Veera Desai Road, Andheri West, Mumbai - 400053',
    gstin: '27AAHCN3366N1ZW',
    iconSrc: 'https://cdn-icons-png.flaticon.com/512/4323/4323994.png', // Updated URL
  },
];


export const socialIcons = [
  { src: 'https://cdn.builder.io/api/v1/image/assets/TEMP/efa71c5f066698260ea813357fafbc35faa24c90ea810c8de469ecb0b2fd1334?placeholderIfAbsent=true&apiKey=8031103fb59b4417b3d6df6558972104', alt: 'Social media icon 1' },
  { src: 'https://cdn.builder.io/api/v1/image/assets/TEMP/094a50e1cade85e59e1d6a909c9c262e852fecbbda68f973048bb0d70cdd74a6?placeholderIfAbsent=true&apiKey=8031103fb59b4417b3d6df6558972104', alt: 'Social media icon 2' },
  { src: 'https://cdn.builder.io/api/v1/image/assets/TEMP/eb1fe52b6de331a1a3a57bd8d8dac220f0535b594d7a293b0e6d9982aca51724?placeholderIfAbsent=true&apiKey=8031103fb59b4417b3d6df6558972104', alt: 'Social media icon 3' },
  { src: 'https://cdn.builder.io/api/v1/image/assets/TEMP/080715395eed069d8f6a99254ba030babd5dd269e69d354d1a83bef811f799b8?placeholderIfAbsent=true&apiKey=8031103fb59b4417b3d6df6558972104', alt: 'Social media icon 4' }
];

export const footerLinks = [
  { text: 'Home', isActive: true },
  { text: 'Advisory', isActive: true },
  { text: 'Prive', isActive: true },
  { text: 'IRIS', isActive: true },
  { text: 'Ethosphere', isActive: true },
  { text: 'Legal', isActive: true },
  { text: 'Blogs', isActive: true },
  { text: 'News', isActive: true },
  { text: 'Contact us', isActive: true }
];




// home page services data
export const servicesData = {
  services: [
    {
      mediaSrc: "/Arranging Custody.gif",
      title: "Arranging Custody",
      description:
        "Ensure the secure and efficient custody of your assets through trusted custodial arrangements and state-of-the-art reporting, giving you peace of mind.",
      mediaAlt: "Custody Arrangement illustration",
      isVideo: true,
      themeColor: "orange",
      bgimage: "/explore/digital-wealth-bg.png",
    },
    {
      mediaSrc: "/Arranging Deals in Investments.gif",
      title: "Arranging Deals in Investments",
      description:
        "Explore exclusive opportunities with expertly arranged investment deals,spanning private equity, structured products, and global market access.",
      mediaAlt: "Deal Arrangement illustration",
      isVideo: true,
      themeColor: "#45DFB1",
      bgimage: "/explore/invest-banking-bg.png",
    },
    {
      mediaSrc: "/Managing assets1.gif",
      title: "Managing Assets",
      description:
        "Entrust your portfolio to our seasoned team, who implement a disciplined approach to asset allocation, balancing growth potential with prudent risk management.",
      mediaAlt: "Ethical investing illustration",
      isVideo: true,
      themeColor: "violet",
      bgimage: "/explore/prive-wealth-bg.png",
    },
    {
      mediaSrc: "/Arranging Credit & Advising on Credit.gif",
      title: "Arranging Credit & Advising on Credit",
      description:
        "Access personalized credit solutions and professional advice for structuring loans and credit facilities, ensuring liquidity while safeguarding your long-term goals.",
      mediaAlt: "Portfolio Management illustration",
      isVideo: true,
       themeColor: "#0dd3ff",
       bgimage: "/explore/fund-advisory-bg.png",
    },
    {
      mediaSrc: "/Legacy Planning & Family Office Management.gif",
      title: "Legacy Planning & Family Office Management",
      description:
        "Comprehensive solutions to manage your legacy and family office requirements, ensuring that your wealth continues to serve future generations seamlessly.",
      mediaAlt: "Portfolio Management illustration",
      isVideo: true,
       themeColor: "#e6b3d2",
      bgimage: "/explore/prive-wealth-bg.png",
    },
    {
      mediaSrc: "/Advising on financial products 1.gif",
      title: "Advising on Financial Products",
      description:
        "Receive expert guidance on a wide range of financial products, carefully tailored to align with your investment objectives, risk tolerance, and legacy planning requirements.",
      mediaAlt: "Financial Product Advising illustration",
      isVideo: true, // Specify it's a video
    },
  ],
};





// footyer 

export const socialIconsss = [
  {
    src: "https://cdn.builder.io/api/v1/image/assets/TEMP/efa71c5f066698260ea813357fafbc35faa24c90ea810c8de469ecb0b2fd1334?placeholderIfAbsent=true&apiKey=8031103fb59b4417b3d6df6558972104",
    alt: "Social media icon"
  },
  {
    src: "https://cdn.builder.io/api/v1/image/assets/TEMP/094a50e1cade85e59e1d6a909c9c262e852fecbbda68f973048bb0d70cdd74a6?placeholderIfAbsent=true&apiKey=8031103fb59b4417b3d6df6558972104",
    alt: "Social media icon"
  },
  {
    src: "https://cdn.builder.io/api/v1/image/assets/TEMP/eb1fe52b6de331a1a3a57bd8d8dac220f0535b594d7a293b0e6d9982aca51724?placeholderIfAbsent=true&apiKey=8031103fb59b4417b3d6df6558972104",
    alt: "Social media icon"
  },
  {
    src: "https://cdn.builder.io/api/v1/image/assets/TEMP/080715395eed069d8f6a99254ba030babd5dd269e69d354d1a83bef811f799b8?placeholderIfAbsent=true&apiKey=8031103fb59b4417b3d6df6558972104",
    alt: "Social media icon"
  }
];

export const navLinks = [
  { label: "Home" },
  { label: "Advisory" },
  { label: "Prive" },
  { label: "IRIS" },
  { label: "Ethosphere" },
  { label: "Legal" },
  { label: "Blogs" },
  { label: "News" },
  { label: "Contact us" }
];
